import { Route } from 'react-router-dom';
import { ListTransactionsPage } from './list-transactions';
import { RequireAuth } from '/src/components';

export { ListTransactionsPage };

export const transactionsRoutes: React.ReactElement[] = [
  <Route
    path="/transactions"
    element={
      <RequireAuth>
        <ListTransactionsPage />
      </RequireAuth>
    }
  />,
];
